<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/myAccountList" [queryParams]="{ tab: 'manageUsers'}">My Accounts</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create User</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black"> User Details</h2>
          <div class="row mt-3">
            <div class="col-md-12 col-md-8">
              <div class="row">
                <div class="col-md-3 required">
                  <label class="control-label" for="firstName">First Name</label>
                  <div class="form-group ">
                    <input type="text" id="firstName" [(ngModel)]="firstName" [ngModelOptions]="{standalone: true}"
                           class="form-control"
                           (blur)="typeFirstName()" [ngClass]="{'is-invalid':statusText1}"
                           onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                           autocomplete="off" required>
                    <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">{{statusText1}}
                    </div>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <label class="control-label" for="lastName">Last Name</label>
                  <div class="form-group ">
                    <input type="text" id="lastName" [(ngModel)]="lastName" [ngModelOptions]="{standalone: true}"
                           class="form-control"
                           (blur)="typeLastName()" [ngClass]="{'is-invalid':statusText2}"
                           onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                           autocomplete="off" required>
                    <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText2">{{statusText2}}
                    </div>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <label class="control-label" for="contactNumber">Phone Number</label>
                  <div class="form-group ">
                    <input type="text" id="contactNumber"
                           onkeypress='return event.charCode >= 48 && event.charCode <= 57' [(ngModel)]="mobileNumber"
                           [ngModelOptions]="{standalone: true}" (blur)="validateMobile()"
                           [ngClass]="{'is-invalid':statusText3}" maxlength="10" class="form-control" required>
                    <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText3">{{statusText3}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 required">
                  <label class="control-label" for="email">Email</label>
                  <div class="form-group ">
                    <input type="text" id="email" [(ngModel)]="email" [ngModelOptions]="{standalone: true}"
                           (blur)="validateEmail()" [ngClass]="{'is-invalid':statusText4}" class="form-control"
                           required>
                    <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText4">{{statusText4}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 px-0 pb-5">
        <div class="d-block mt-2" *ngFor="let role of groupList | slice:0: sliceUPto(groupList?.length)-1;let i=index;">
          <div class="col">
            <div class="inner-box">
              <h2 class="text-black">{{role.groupDescription}}</h2>
              <hr class="mt-1 mb-2">
              <div class="row align-items-center"
                   *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
                <div class="col-lg-3 col-md-5 col-sm-5  text-center">
                  <div class="toggle-2">
                    <input type="checkbox" name="onoffswitch" id="{{role?.groupId}}" class="checkbox"
                           [ngModelOptions]="{standalone: true}" [(ngModel)]="role.enableAll"
                           (change)="allStatusChange(role)"/>
                    <label for="{{role?.groupId}}" class="toggle">
                      <span>ON</span><span>OFF</span>
                    </label>
                  </div>
                </div>
                <div class="col-lg-9 col-md-7 col-sm-7" [ngClass]="{'text-dark-orange':role.enableAll}">
                  <label class="mb-0">Allow all access</label>
                </div>
              </div>
              <hr class="my-2"
                  *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
              <div class="row">
                <div class="col-12 my-1" *ngFor="let action of role.securityTypes">
                  <div class="row align-items-center">
                    <div class="col-lg-3 col-md-5 col-sm-5  text-center">
                      <div class="toggle-2">
                        <input type="checkbox" name="onoffswitch" id="{{action.securityTypeId}}" class="checkbox"
                               [ngModelOptions]="{standalone: true}" [(ngModel)]="action.enabled"
                               (change)="statusChange(action)"/>
                        <label for="{{action.securityTypeId}}" class="toggle">
                          <span>ON</span><span>OFF</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-9 col-md-7 col-sm-7" [ngClass]="{'text-dark-orange':action.status==='ACTIVE'}">
                      <label class="mb-0">{{action.securityName}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 px-0  pb-5">
        <div class="d-block  mt-2"
             *ngFor="let role of groupList | slice:sliceUPto(groupList?.length)-1:groupList?.length;let i = index;">
          <div class="col">
            <div class="inner-box">
              <h2 class="text-black">{{role.groupDescription}}</h2>
              <hr class="mt-1 mb-2">
              <div class="row align-items-center"
                   *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
                <div class="col-lg-3 col-md-5 col-sm-5  text-center">
                  <div class="toggle-2">
                    <input type="checkbox" name="onoffswitch" id="{{role?.groupId}}" class="checkbox"
                           [ngModelOptions]="{standalone: true}" [(ngModel)]="role.enableAll"
                           (change)="allStatusChange(role)"/>
                    <label for="{{role?.groupId}}" class="toggle">
                      <span>ON</span><span>OFF</span>
                    </label>
                  </div>
                </div>
                <div class="col-lg-9 col-md-7 col-sm-7 " [ngClass]="{'text-dark-orange':role.enableAll}">
                  <label class="mb-0">Allow all access</label>
                </div>
              </div>
              <hr class="my-2"
                  *ngIf="['outbound_orders','inventory','work_orders','inbound_orders'].indexOf(role.groupCode)>-1">
              <div class="row">
                <div class="col-12  my-1" *ngFor="let action of role.securityTypes">
                  <div class="row align-items-center ">
                    <div class="col-lg-3 col-md-5 col-sm-5  text-center">
                      <div class="toggle-2">
                        <input type="checkbox" name="onoffswitch" id="{{action.securityTypeId}}" class="checkbox"
                               [ngModelOptions]="{standalone: true}" [(ngModel)]="action.enabled"
                               (change)="statusChange(action)"/>
                        <label for="{{action.securityTypeId}}" class="toggle">
                          <span>ON</span><span>OFF</span>
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-9 col-md-7 col-sm-7" [ngClass]="{'text-dark-orange':action.status==='ACTIVE'}">
                      <label class="mb-0">{{action.securityName}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/myAccountList" class="btn btn-cancel">Cancel</button>
      <button type="submit" (click)="submit()" class="btn btn-orange ml-2">Save</button>
    </div>
  </div>
</div>
